import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import MonetaryAmount from 'common/formatting/MonetaryAmount';
import { typographyCss } from 'common/typography';
import { useCampaignModuleContext } from 'modules/campaigns/context';

import CampaignFormItem from '../CampaignFormItem';

const BudgetValueStaticText = styled.span`
  ${typographyCss.Body3};
  font-weight: 500;
  color: ${cbSemanticCssVars.textSecondary};
  margin-block-start: 12px;
`;
export const EndOfDayBudgetDetails = ({
  tooltip,
  budget,
  'data-test-id': dataTestid,
}: {
  'data-test-id'?: string;
  tooltip?: React.ReactNode;
  budget: number;
}) => {
  const { currency } = useCampaignModuleContext();

  return (
    <CampaignFormItem
      data-test-id={dataTestid}
      title={<FormattedMessage id="campaigns.form.budget.end-of-day-label" />}
      subtitle={<FormattedMessage id="campaigns.form.budget.end-of-day-subtitle" />}
      tooltip={tooltip}
      value={
        <BudgetValueStaticText>
          <MonetaryAmount amount={budget} currency={currency} />
        </BudgetValueStaticText>
      }
    />
  );
};
